/* Upload window money checks: payment credited under the order value, and products sold under cost.
   The partner must tick "send anyway" on such a parcel; the office then sees the same marks in the ERP. */
import { AlertTriangle } from "lucide-react";
import { money } from "./portalApi";

// Product without pills-per-strip in the office list: its value stays rate × qty until the office adds the packing
export const PackTag = () => (
  <span className="ml-1 rounded bg-amber-100 px-1 text-[10px] font-semibold text-amber-800" title="Pills per strip not set by the office yet — value counted as rate × qty" data-testid="portal-pack-missing">packing missing</span>);

// Name not found in the office product list — the order still goes in; the office sets the product
export const AliasTag = () => (
  <span className="ml-1 rounded bg-sky-100 px-1 text-[10px] font-semibold text-sky-800" title="Not found in the office product list — the office will match it" data-testid="portal-no-alias">not in product list</span>);

export const needsMoneyOk = (p) => !p.errors?.length && (p.short_payment > 0 || p.loss > 0);

export const MoneyChecks = ({ p, i, ok, onOk, prefix }) => {
  if (!needsMoneyOk(p)) return null;
  return (
    <div className="mt-1.5 space-y-1 rounded-lg border border-rose-300 bg-white p-2 font-semibold" data-testid={`${prefix}-money-${i}`}>
      {p.short_payment > 0 && <div className="flex items-start gap-1 text-amber-800" data-testid={`${prefix}-short-${i}`}>
        <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" /> Less payment received: paid {money(p.payment_amount, "INR")} of {money(p.grand_total, "INR")} — short by {money(p.short_payment, "INR")}</div>}
      {p.loss > 0 && <div className="flex items-start gap-1 text-rose-700" data-testid={`${prefix}-loss-${i}`}>
        <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" /> Loss: {p.below_cost} product(s) sold below cost — you lose {money(p.loss, "INR")} on this parcel</div>}
      <label className="flex cursor-pointer items-center gap-2 text-slate-700">
        <input type="checkbox" checked={!!ok} onChange={(e) => onOk(e.target.checked)} data-testid={`${prefix}-money-ok-${i}`} />
        Yes, I know — send anyway (the office will see this mark)</label>
    </div>
  );
};
